import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private currentLang: string = 'en';
  private readonly LANG_KEY = 'preferred_language';
  private changeLangEmit = new Subject<any>();
  changeLangEmitted$ = this.changeLangEmit.asObservable();
  language: string = 'en';

  constructor(
    private translate: TranslateService,
    private http: HttpClient
  ) {
    this.translate.setDefaultLang('en');
    // Load language from localStorage or use default
    const savedLang = localStorage.getItem(this.LANG_KEY);
    this.changeLanguage(savedLang || 'en');
  }

  // Change the current language
  changeLanguage(language: string): void {
    this.currentLang = language;
    this.language = language;
    this.translate.use(language);
    // Save language preference to localStorage
    localStorage.setItem(this.LANG_KEY, language);
  }

  // Get a specific translation using ngx-translate
  getTranslation(key: string): string {
    return this.translate.instant(key);
  }

  // Get current language
  getCurrentLang(): string {
    return this.currentLang;
  }

  changeLang($event) {
    this.changeLangEmit.next($event);
  }
}
